import { useSyncExternalStore } from 'react';

// What the server did with a connect code you posted in a singles match chat
// ({code, previous, match_id, type}, from chat/send's response), kept per match so
// the match card can say so and offer Undo. Only this tab knows about it.
const notices = new Map();
const listeners = new Set();

function notify() {
	listeners.forEach((listener) => listener());
}

export function setConnectCodeNotice(matchId, notice) {
	notices.set(Number(matchId), notice);
	notify();
}

export function clearConnectCodeNotice(matchId) {
	notices.delete(Number(matchId));
	notify();
}

export function getConnectCodeNotice(matchId) {
	return notices.get(Number(matchId)) || null;
}

function subscribe(listener) {
	listeners.add(listener);
	return () => listeners.delete(listener);
}

export function useConnectCodeNotice(matchId) {
	return useSyncExternalStore(subscribe, () => getConnectCodeNotice(matchId), () => null);
}
